export default
{
    CH: 'CHF',
    AT: 'EUR',
    DE: 'EUR',
    FR: 'EUR',
    IT: 'EUR',
    PT: 'EUR',
    ES: 'EUR',
    GR: 'EUR',
    CY: 'EUR',
    MT: 'EUR',
    BE: 'EUR',
    NL: 'EUR',
    LU: 'EUR',
    IE: 'EUR',
    FI: 'EUR',
    EE: 'EUR',
    LT: 'EUR',
    LV: 'EUR',
    SK: 'EUR',
    SI: 'EUR'
}